/*
* @Author: your name
* @Date: 2021-12-22 09:59:02
* @LastEditTime: 2022-09-21 18:13:19
* @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
* @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
* @FilePath: \Code\src\main.js
*/


import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'

import CheckId from '@/components/CheckId.vue'
import ScanQR from '@/components/ScanQR.vue'
import BList from '@/components/BindList.vue'

Vue.use(VueRouter)

import AjaxPlugin from 'vux/src/plugins/ajax/index.js'

Vue.use(AjaxPlugin)

import WechatPlugin from 'vux/src/plugins/wechat/index.js'

Vue.use(WechatPlugin)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import AlertPlugin from 'vux/src/plugins/alert/index.js'

Vue.use(AlertPlugin)

import VConsole from 'vconsole';

const vConsole = new VConsole();

import VueBus from 'vue-bus';
Vue.use(VueBus);


import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

Vue.use(VXETable)


const routes = [{
path: '/',
component: CheckId
},
{
path: '/CheckId',

component: CheckId
},
{
path: '/ScanQR',

component: ScanQR
},
{
path: '/BList',

component: BList
}]

const router = new VueRouter({
routes
})

FastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js